import { render } from "./domna.vue?vue&type=template&id=9c3e0bea"
import script from "./domna.vue?vue&type=script&lang=js"
export * from "./domna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__